const routes = {
  getReports: 'report',
  getRefundExchange: 'refund-exchange-sale',
  calculateRefundExchange: 'refund-exchange-sale/calculate',
  getRefund: 'refund-exchange-sale/refund',
  getExchange: 'refund-exchange-sale/exchange',
  generateExchangeReceipt: 'refund-exchange-sale/exchange-receipt/:id',
  generateRefundReceipt: 'refund-exchange-sale/refund-receipt/:id',
};
 
export default routes;